/**
 * Retrieve the translation of text.
 * @param {string} text
 *
 * @return {string} Translated text
 */
const __ = (text) => {
	return text;
};

/**
 * Returns a formatted string. If an error occurs in applying the format, the
 * original format string is returned.
 *
 * @param {string} format The format of the string to generate.
 * @param {...*}   args   Arguments to apply to the format.
 *
 * @return {string} The formatted string.
 */
const sprintf = (format, ...args) => {
	let argIndex = 0;

	return format.replace(/%([sd])/g, (match, type) => {
		const arg = args[argIndex++];

		switch (type) {
			case 's':
			case 'd':
				return String(arg);
			default:
				return match;
		}
	});
};

export { __, sprintf };
